export const inIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return false;
    }
}

export const getWidgetAlbumUrl = (photographId, albumId) => {
    return `${process.env.REACT_APP_PUBLIC_URL}/photographs/${photographId}/albums/${albumId}`
}
